import { ProgressiveImage } from "@circle-react-shared/ProgressiveImage";
import type { ImageVariants } from "@circle-react-shared/ProgressiveImage/utils";
import type { MouseEventHandler } from "react";

import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface ImageBlockProps {
  alignment?: "left" | "center" | "right";
  aspectRatio?: string;
  imageVariants?: ImageVariants;
  isZoomable?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  src: string;
  widthRatio?: number;
}

export const ImageBlock = ({
  alignment,
  aspectRatio,
  imageVariants,
  isZoomable = false,
  onClick,
  src,
  widthRatio = 1,
}: ImageBlockProps) => (
  <div
    style={{ width: `${widthRatio * 100}%` }}
    className={classNames("group relative", {
      "mx-auto": alignment === "center",
      "ml-auto": alignment === "right",
    })}
  >
    <button
      type="button"
      className="w-full"
      onClick={onClick}
      aria-label={t("tiptap.extensions.image_preview.view_attachment")}
      disabled={!onClick}
    >
      <ProgressiveImage
        alt=""
        src={src}
        className={classNames("w-full rounded-lg lg:rounded-none", {
          "cursor-zoom-in": isZoomable,
        })}
        srcVariants={imageVariants}
        aspectRatio={aspectRatio}
      />
    </button>
  </div>
);
